/**
 * Event Context Factory
 *
 * Creates the CellEventContext that bridges AppState to CellEvents.
 */

import { appState } from '../state/AppState';
import { showOverlayDivs } from './domSetup';
import type { CellEventContext } from '../types/events.types';

/**
 * Create the event context for CellEvents
 */
export function createEventContext(): CellEventContext {
    return {
        getIsHorizontal: () => appState.isHorizontal,
        setIsHorizontal: (v: boolean) => {
            appState.isHorizontal = v;
        },
        getIsBuilderMode: () => appState.isBuilderMode,
        getCurrentElement: () => appState.currentElement,
        setCurrentElement: (el: HTMLElement | null) => {
            appState.currentElement = el;
        },
        getCurrentCellId: () => appState.currentCellId,
        setCurrentCellId: (id: number) => {
            appState.currentCellId = id;
        },
        getCurrentSelection: () => appState.currentSelection,
        setCurrentSelection: (sel: number[]) => {
            appState.currentSelection = sel;
        },
        getInverseSelection: () => appState.inverseSelection,
        setInverseSelection: (sel: number[]) => {
            appState.inverseSelection = sel;
        },
        getSyncEditing: () => appState.syncEditing,
        getCellHighlight: () => appState.cellHighlight,
        setCellHighlight: (v: boolean) => {
            appState.cellHighlight = v;
        },
        getClueMarking: () => appState.clueMarking,
        getValidCharPattern: () => appState.validCharPattern,
        setUnsaved: () => {
            appState.isSaved = false;
            showOverlayDivs();
        },
        setUnverified: () => {
            appState.isVerified = false;
        },
    };
}
